import React, { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';

interface TooltipTourContextType {
  isRunning: boolean;
  startTour: () => void;
  stopTour: () => void;
}

const TooltipTourContext = createContext<TooltipTourContextType | undefined>(undefined);

export function useTooltipTour() {
  const context = useContext(TooltipTourContext);
  if (!context) {
    throw new Error('useTooltipTour must be used within a TooltipTourProvider');
  }
  return context;
}

interface TooltipTourProviderProps {
  children: ReactNode;
}

export const TooltipTourProvider: React.FC<TooltipTourProviderProps> = ({ children }) => {
  const [isRunning, setIsRunning] = useState(false);

  const startTour = useCallback(() => {
    setIsRunning(true);
  }, []);

  const stopTour = useCallback(() => {
    setIsRunning(false);
  }, []);

  const value = useMemo(
    () => ({ isRunning, startTour, stopTour }),
    [isRunning, startTour, stopTour]
  );

  return (
    <TooltipTourContext.Provider value={value}>
      {children}
    </TooltipTourContext.Provider>
  );
};
